import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import admin, { axiosWithToken, functionBaseUrl } from "../common/firebase";

export const useCustomTokenAuth = () => {
  const history = useHistory();

  const checkIfUserExists = async (creds) => {
    try {
      const response = await axiosWithToken(
        functionBaseUrl + "/api/users/" + creds.user.uid,
        {
          method: "get",
        }
      );
      console.log("User exists:", response);
      return response;
    } catch (error) {
      toast.info("User does not exist for this account, please sign up.");
    }
  };

  const signInWithCustomToken = async (token) => {
    if (!token) {
      return;
    }
    try {
      const creds = await admin.auth().signInWithCustomToken(token);
      console.log("SIGNED IN WITH CUSTOM TOKEN:", creds?.user);

      const userExist = await checkIfUserExists(creds);

      if (!userExist) {
        if (window.location.href.includes("mobileClient")) {
          history.push("/sign-up?mobileClient");
        } else {
          history.push("/sign-up");
        }
      }
    } catch (error) {
      toast.info("User does not exist for this account, please sign up.");
    }
  };

  return { signInWithCustomToken };
};
